import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';
import { hasPermissionOrAdmin } from 'helpers/permissions';
import { INCENTIVES_PERMISSIONS } from 'permissions/incentives';
import { useAppSelector } from 'store/hook';

import { useCommunityIncentivesContext } from './CommunityIncentivesContext';
import CommunityIncentivesFilters from './CommunityIncentivesFilters';
import { INCENTIVE_MODAL_TYPE } from './constants';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const StyledButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CommunityIncentivesControls = () => {
  const { setModalType } = useCommunityIncentivesContext();
  const { currentUser } = useAppSelector((state) => state.auth);

  const canAddIncentive = hasPermissionOrAdmin(currentUser, [INCENTIVES_PERMISSIONS.ADD]);

  return (
    <Container>
      <CommunityIncentivesFilters />
      {canAddIncentive && (
        <StyledButton
          type={'primary'}
          icon={<img src="/icons/add.svg" height={22} width={22} alt="add" />}
          onClick={() => setModalType(INCENTIVE_MODAL_TYPE.CREATE)}
        >
          Add Incentive
        </StyledButton>
      )}
    </Container>
  );
};

export default CommunityIncentivesControls;
